<script>
    export default {
      props: {
        show: Boolean,
        requisitionId: Number
      },
      data() {
        return {
          checkOffType: null,
          checkOffDate: null
        }
      },
      methods: {
        getCurrentDate() {
          var d = new Date();
          var month = '' + (d.getMonth() + 1);
          var day = '' + d.getDate();
          var year = d.getFullYear();

          if (month.length < 2) 
              month = '0' + month;
          if (day.length < 2) 
              day = '0' + day;

          return [year, month, day].join('-');
        },
      },
      mounted() {
        this.checkOffDate = this.getCurrentDate();
      },
    }
</script>

<template>
  <Transition name="modal">
    <div v-if="show" class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container" ref="modalContainer">
          <button class="close-button" @click="$emit('close')">&times;</button>
          <div class="modal-header">
            <slot name="header">default header</slot>
          </div>
          <div class="modal-body">
            <slot name="body">
                <label for="check_off_type">Check off type</label>
                <select v-model="checkOffType" name="check_off_type" class="fixed-height">
                    <option disabled value="">Please select one</option>
                    <option value="skills_assessment">Skills assessment</option>
                    <option value="onboarding">Onboarding</option>
                    <option value="start">Starting</option>
                </select>
                <label for="check_off_date">Check off date</label>
                <input type="date" v-model="checkOffDate" name="check_off_date" class="fixed-height">
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
                <div v-if="checkOffType && checkOffDate">
                  Showing {{ checkOffType }} check-off for {{ checkOffDate }}.
                </div>
              <a
                class="button apply-filter no-margin no-underline"
                :href="`/recruiter/active-requisitions/check-off/${checkOffType}/${requisitionId}/${checkOffDate}`">
                Submit
              </a>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<style>

    .modal-mask {
      position: fixed;
      z-index: 9998;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      display: table;
      transition: opacity 0.3s ease;
    }

    .modal-wrapper {
      display: table-cell;
      vertical-align: middle;
    }

    .modal-container {
      width: 300px;
      margin: 0px auto;
      padding: 20px 30px;
      background-color: #fff;
      border-radius: 2px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
      transition: all 0.3s ease;
    }

    .close-button {
      position: relative;
      padding-top: 4px;
      right: -10rem;
      top: -.5rem;
    }

    .modal-body {
      margin: 20px 0;
    }

    .modal-body > .fixed-height {
      height: auto;
    }

    .modal-default-button {
      float: right;
    }

    .modal-enter-from {
      opacity: 0;
    }

    .modal-leave-to {
      opacity: 0;
    }

    .modal-enter-from .modal-container,
    .modal-leave-to .modal-container {
      -webkit-transform: scale(1.1);
      transform: scale(1.1);
    }

    .no-underline {
      text-decoration: none;
    }
</style>